class WiggensbachCertificates extends HTMLElement {
  connectedCallback() {
    this.openButtons = Array.from(this.querySelectorAll('[data-wig-certificates-open]'));
    this.lightbox = this.querySelector('[data-wig-certificates-lightbox]');
    this.lightboxDialog = this.querySelector('.wig-certificates__lightbox-dialog');
    this.lightboxImage = this.querySelector('[data-wig-certificates-lightbox-image]');
    this.lightboxCaption = this.querySelector('[data-wig-certificates-lightbox-caption]');
    this.closeButtons = Array.from(this.querySelectorAll('[data-wig-certificates-close]'));
    this.activeTrigger = null;

    if (!this.lightbox || !this.lightboxImage || this.openButtons.length === 0) return;

    this.onKeyDown = (event) => {
      if (event.key === 'Escape' && !this.lightbox.hidden) {
        this.closeLightbox();
      }
    };

    this.openButtons.forEach((button) => {
      button.addEventListener('click', () => this.openLightbox(button));
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.closeLightbox());
    });

    document.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    if (this.onKeyDown) {
      document.removeEventListener('keydown', this.onKeyDown);
    }

    if (this.lightbox && !this.lightbox.hidden) {
      document.body.classList.remove('wig-certificates-lightbox-open');
    }
  }

  openLightbox(button) {
    const imageUrl = button.dataset.fullImage;
    if (!imageUrl) return;

    this.activeTrigger = button;
    this.lightboxImage.src = imageUrl;
    this.lightboxImage.alt = button.dataset.alt || '';

    this.setCaption(button.dataset.caption || '');

    this.lightbox.hidden = false;
    document.body.classList.add('wig-certificates-lightbox-open');

    window.requestAnimationFrame(() => {
      if (this.lightboxDialog) {
        this.lightboxDialog.focus();
      }
    });
  }

  closeLightbox() {
    if (!this.lightbox || this.lightbox.hidden) return;

    this.lightbox.hidden = true;
    this.lightboxImage.removeAttribute('src');
    this.lightboxImage.alt = '';
    this.setCaption('');
    document.body.classList.remove('wig-certificates-lightbox-open');

    if (this.activeTrigger) {
      this.activeTrigger.focus();
      this.activeTrigger = null;
    }
  }

  setCaption(caption) {
    if (!this.lightboxCaption) return;

    this.lightboxCaption.textContent = caption;
    this.lightboxCaption.hidden = caption.length === 0;
  }
}

if (!customElements.get('wiggensbach-certificates')) {
  customElements.define('wiggensbach-certificates', WiggensbachCertificates);
}
